<template>
    <div>
        <b-row>
            <b-col sm="6" v-if="!hasOtherPairedItems">
                <Molded>
                    <span class="manual-reconcile-confirm-modal-label">Extrato Bancário</span>
                    <div class="manual-reconcile-confirm-modal-description">{{ statementItem.description }}</div>
                    <div class="manual-reconcile-confirm-modal-value-row">
                        <span class="manual-reconcile-confirm-modal-subtext">{{ statementItem.dueDate }}</span>
                        <span class="manual-reconcile-confirm-modal-value"
                            :class="statementItem.value < 0 ? 'manual-reconcile-confirm-modal-value-negative' : 'manual-reconcile-confirm-modal-value-positive'">
                            {{ statementItem.value | currency }}
                        </span>
                    </div>
                </Molded>
            </b-col>
            <b-col sm="6" v-else class="manual-reconcile-confirm-modal-group-col">
                <Molded class="manual-reconcile-confirm-modal-group-molded" :style="{ maxHeight: groupMaxHeight }"
                    :paddingRight="4" :paddingLeft="12">
                    <span class="manual-reconcile-confirm-modal-label">
                        Itens vinculados ({{ linkedStatementItems.length }})
                    </span>
                    <div class="manual-reconcile-confirm-modal-group-list">
                        <div class="manual-reconcile-confirm-modal-group-item" v-for="item in linkedStatementItems"
                            :key="item.id">
                            <div class="manual-reconcile-confirm-modal-group-item-description">
                                {{ item.description }}
                            </div>
                            <div class="manual-reconcile-confirm-modal-value-row">
                                <span class="manual-reconcile-confirm-modal-subtext">{{ item.dueDate }}</span>
                                <span class="manual-reconcile-confirm-modal-group-item-value"
                                    :class="item.value < 0 ? 'manual-reconcile-confirm-modal-value-negative' : 'manual-reconcile-confirm-modal-value-positive'">
                                    {{ item.value | currency }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="manual-reconcile-confirm-modal-group-total">
                        Total pareado:
                        <strong :class="recordItem.value < 0 ? 'manual-reconcile-confirm-modal-value-negative' : 'manual-reconcile-confirm-modal-value-positive'">
                            {{ (recordItem.value < 0 ? -recordItem.pairedTotal : recordItem.pairedTotal) | currency }}
                        </strong>
                        de
                        <strong :class="recordItem.value < 0 ? 'manual-reconcile-confirm-modal-value-negative' : 'manual-reconcile-confirm-modal-value-positive'">
                            {{ recordItem.baseRemainingValue | currency }}
                        </strong>
                    </div>
                </Molded>
            </b-col>
            <b-col sm="6">
                <Molded ref="recordColumn">
                    <span class="manual-reconcile-confirm-modal-label">Lançamento Cadastrado</span>
                    <div class="manual-reconcile-confirm-modal-description">
                        {{ recordItem.recipientName || recordItem.description }}
                    </div>
                    <div class="manual-reconcile-confirm-modal-subtext" v-if="recordItem.recipientName">
                        {{ recordItem.description }}
                    </div>
                    <div class="manual-reconcile-confirm-modal-value-row">
                        <span class="manual-reconcile-confirm-modal-subtext">{{ recordItem.dueDate }}</span>
                        <span class="manual-reconcile-confirm-modal-value"
                            :class="recordItem.value < 0 ? 'manual-reconcile-confirm-modal-value-negative' : 'manual-reconcile-confirm-modal-value-positive'">
                            {{ recordItem.value | currency }}
                        </span>
                    </div>
                    <div class="manual-reconcile-confirm-modal-existing-balance" v-if="hasExistingBalance">
                        Já possui baixa parcial de {{ existingPaidAmount | currency }} · Saldo atual:
                        {{ recordItem.baseRemainingValue | currency }}
                    </div>
                    <div class="manual-reconcile-confirm-modal-details">
                        <Loading type="line" :center="false" v-if="loadingDetails" />
                        <Select title="Categoria" url="api/v1/financial/chart-of-accounts/select-all"
                            :propsParams="{ any: typeCostCenter }" :showNewRegister="false" :required="true"
                            v-model="chartOfAccounts">
                        </Select>
                        <Select title="Tipo de Pagamento" url="/api/v1/financial/type-payment/select-all"
                            :showNewRegister="false" :required="true" v-model="typePayment">
                        </Select>
                        <Select title="Conta Bancária (Extrato)" url="api/v1/financial/bank-account/select-all"
                            :showNewRegister="false" :required="true" :disabled="true" v-model="bankAccount">
                        </Select>
                    </div>
                </Molded>
            </b-col>
        </b-row>

        <div class="manual-reconcile-confirm-modal-alert" v-if="bankAccountWarning">
            <Alert type="warning">{{ bankAccountWarning }}</Alert>
        </div>

        <div class="manual-reconcile-confirm-modal-actions text-center">
            <Button _key="btnConfirmManualReconcile" title="Confirmar Conciliação" size="medium" type="primary"
                :disabled="!canConfirm" :clicked="onConfirm" />
            <Button _key="btnCancelManualReconcile" title="Cancelar" size="medium" type="danger" :clicked="onCancel" />
        </div>
    </div>
</template>
<script>

import Molded from "@/ui/layout/Molded";
import Alert from "@/ui/layout/Alert";
import Button from "@/ui/forms/Button";
import Select from "@/ui/forms/Select";
import Loading from "@/ui/shared/Loading.vue";

import PayableReceivableService from "../../services/payableReceivable.service.js";
import reconciliationRecordMixin, { costCenterType } from "../../mixins/reconciliationRecord.mixin.js";

export default {
    name: "ManualReconcileConfirmModal",
    mixins: [reconciliationRecordMixin],
    components: { Molded, Alert, Button, Select, Loading },
    props: {
        statementItem: Object,
        recordItem: Object,
        statement: { type: Array, default: () => [] },
    },
    data() {
        return {
            loadingDetails: false,
            groupMaxHeight: null,
            chartOfAccounts: (this.recordItem.chartOfAccounts && this.recordItem.chartOfAccounts.id) ? { ...this.recordItem.chartOfAccounts } : {},
            typePayment: (this.recordItem.typePayment && this.recordItem.typePayment.id) ? { ...this.recordItem.typePayment } : {},
            bankAccount: (this.statementItem.bankAccount && this.statementItem.bankAccount.id) ? { ...this.statementItem.bankAccount } : {},
        };
    },
    mounted() {
        this.loadRecordItemDetails();
        this.syncGroupHeight();
        window.addEventListener("resize", this.syncGroupHeight);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.syncGroupHeight);
    },
    computed: {
        typeCostCenter() {
            return costCenterType(this.recordItem.type);
        },
        hasMixedBankAccounts() {
            let ids = this.linkedStatementItems
                .map((item) => (item.bankAccount && item.bankAccount.id ? item.bankAccount.id : ''))
                .filter((id) => id != '');
            return ids.some((id) => id != ids[0]);
        },
        bankAccountWarning() {
            if (this.hasMixedBankAccounts)
                return "Os itens vinculados são de contas bancárias diferentes. Só é possível conciliar itens do extrato da mesma conta bancária.";
            if (!this.bankAccount || !this.bankAccount.id)
                return "Este item do extrato não possui conta bancária vinculada. Reimporte o extrato informando a conta bancária para poder conciliar.";
            return "";
        },
        canConfirm() {
            return !!(this.chartOfAccounts && this.chartOfAccounts.id)
                && !!(this.typePayment && this.typePayment.id)
                && !!(this.bankAccount && this.bankAccount.id)
                && !this.hasMixedBankAccounts;
        },
    },
    methods: {
        syncGroupHeight() {
            this.$nextTick(() => {
                let recordColumn = this.$refs.recordColumn;
                if (recordColumn) this.groupMaxHeight = recordColumn.$el.offsetHeight + 'px';
            });
        },
        async loadRecordItemDetails() {
            if (!this.recordItem || !this.recordItem.id) return;

            this.loadingDetails = true;
            const response = await PayableReceivableService.getAllPartialPayment(this.recordItem.id);
            if (response && response.success) {
                const payableReceivable = response.content.payableReceivable || {};

                this.chartOfAccounts = payableReceivable.chartOfAccounts && payableReceivable.chartOfAccounts.id
                    ? { id: payableReceivable.chartOfAccounts.id, content: payableReceivable.chartOfAccounts.content }
                    : this.chartOfAccounts;
                this.typePayment = payableReceivable.typePayment && payableReceivable.typePayment.id
                    ? { id: payableReceivable.typePayment.id, content: payableReceivable.typePayment.content }
                    : this.typePayment;
                if (response.content.remainingValue !== undefined && response.content.remainingValue !== null) {
                    this.recordItem.baseRemainingValue = Math.abs(response.content.remainingValue);
                }
            }
            this.loadingDetails = false;
            this.syncGroupHeight();
        },
        onConfirm() {
            this.$emit('confirm', {
                chartOfAccounts: this.chartOfAccounts,
                typePayment: this.typePayment,
                bankAccount: this.bankAccount,
            });
        },
        onCancel() {
            this.$emit('cancel');
        },
    },
};
</script>
<style scoped>
.manual-reconcile-confirm-modal-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--text-secondary);
}

.manual-reconcile-confirm-modal-description {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    margin-top: 4px;
}

.manual-reconcile-confirm-modal-subtext {
    font-size: 12px;
    color: var(--text-secondary);
    margin-top: 2px;
}

.manual-reconcile-confirm-modal-value-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
}

.manual-reconcile-confirm-modal-value {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
}

.manual-reconcile-confirm-modal-existing-balance {
    font-size: 11.5px;
    color: var(--color-warning);
    margin-top: 6px;
}

.manual-reconcile-confirm-modal-details {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid var(--border-subtle);
    font-size: 12.5px;
    color: var(--text-primary);
}

.manual-reconcile-confirm-modal-group-col {
    display: flex;
}

.manual-reconcile-confirm-modal-group-molded {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.manual-reconcile-confirm-modal-group-list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    margin-top: 4px;
}

.manual-reconcile-confirm-modal-group-item {
    padding: 8px 10px;
    border-bottom: 1px solid var(--border-subtle);
}

.manual-reconcile-confirm-modal-group-item .manual-reconcile-confirm-modal-value-row {
    margin-top: 2px;
}

.manual-reconcile-confirm-modal-group-item:last-child {
    border-bottom: none;
}

.manual-reconcile-confirm-modal-group-item-description {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
}

.manual-reconcile-confirm-modal-group-item-value {
    font-size: 13px;
    font-weight: 700;
    color: var(--text-primary);
}

.manual-reconcile-confirm-modal-group-total {
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px solid var(--border-subtle);
    font-size: 12.5px;
    color: var(--text-primary);
}

.manual-reconcile-confirm-modal-value-positive {
    color: var(--color-success);
}

.manual-reconcile-confirm-modal-value-negative {
    color: var(--color-danger);
}

.manual-reconcile-confirm-modal-alert {
    margin-top: 14px;
}

.manual-reconcile-confirm-modal-actions {
    margin-top: 18px;
}
</style>
